<template>
  <div class="list_frame">
    <el-table
      ref="multipleTable"
      :data="listData"
      tooltip-effect="dark"
      style="width: 100%"
      @row-click="toggleSelection"
      @selection-change="handleSelectionChange"
    >
      <template v-for="(val,ind) in listForm">
        <slot
          v-if="val.slot"
          :name="val.slot"
        />
        <component
          :is="val.component"
          v-else-if="val.component"
          :key="val.prop"
          :celldata="val"
          :prop="val.prop"
          :label="val.label"
          :type="val.type"
          :width="val.width"
          :fixed="val.fixed"
          :sortable="val.sortable"
          :index="val.customIndex"
          :class-name="val.className"
          :align="val.align"
        />
        <el-table-column
          v-else
          :key="ind"
          :prop="val.prop"
          :label="val.label"
          :type="val.type"
          :width="val.width"
          :fixed="val.fixed"
          :sortable="val.sortable"
          :index="val.customIndex"
          :class-name="val.className"
          :align="val.align"
        />
      </template>
    </el-table>
  </div>
</template>
<script>
import multiLines from '@/components/ListSlot/MultiLines'
import colored from '@/components/ListSlot/Colored'
export default {
  components: {
    'multi-lines': multiLines,
    colored
  },
  props: {
    listForm: Array,
    listData: Array
  },
  data () {
    return {
      multipleSelection: []
    }
  },
  methods: {
    toggleSelection (row) {
      console.log(row)
      if (row) {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    handleSelectionChange (val) { // checkbox選擇變更
      // this.multipleSelection = val;
      console.log(val)
      this.$emit('update:selections', val)
    }
  }
}
</script>
<style lang="sass" scoped>
.list_frame
  ::v-deep .el-table
    +basicTable
</style>
